export default __webpack_public_path__ + "static/media/google-job-icon.5c7177b0.svg";